import { ReactNode } from "react";
import { Route, Routes, useParams, Link } from "react-router-dom";

import Login from "../pages/Login";
import IntlWrapper from "../pages/IntlWrapper";
import Home from "../pages/Home";
import ProjectDetail from "../pages/ProjectDetail";
import AuthenticatedGurad from "./AuthenticatedGuard";
import langs from "../locales/SCQuick3DDict.json";
import i18n from "../locales/i18n";
import Upload from "../pages/Upload";
import { EDisplayType } from "../pages/ProjectDetail";
import { config } from "../config/config";

export const UserRouter = () => {
  const url = new URL(window.location.href);
  const urlPathname = url.pathname.substring(1);

  return (
    <Routes>
      <Route path="/login" element={<Login urlProjectId={urlPathname} />} />
      <Route
        path="/"
        element={
          <AuthenticatedGurad path="/">
            <IntlWrapper usingUserSiteContext={true}>
              <Home />
            </IntlWrapper>
          </AuthenticatedGurad>
        }
      />
      <Route
        path="/:projectId"
        element={
          <AuthenticatedGurad path="/:projectId">
            <IntlWrapper usingUserSiteContext={true}>
              <ProjectDetail displayType={EDisplayType.Web} />
            </IntlWrapper>
          </AuthenticatedGurad>
        }
      />
      <Route
        path="/ios/:lang/:projectId"
        element={
          <AuthenticatedGurad path="/ios/:lang/:projectId">
            <IntlWrapper usingUserSiteContext={false}>
              <LangWrap>
                <ProjectDetail displayType={EDisplayType.iOS} />
              </LangWrap>
            </IntlWrapper>
          </AuthenticatedGurad>
        }
      />
      {config.debugMode ? (
        <Route path="/debug/upload" element={<Upload />} />
      ) : (
        ""
      )}
      <Route
        path="*"
        element={
          <div>
            <h2
              style={{ color: "white", textAlign: "center", marginTop: "20px" }}
            >
              404 Not Found
            </h2>
            <p style={{ color: "white", textAlign: "center" }}>
              <Link to="/">TOPへ戻る</Link>
            </p>
          </div>
        }
      />
    </Routes>
  );
};

type LangProps = {
  children: ReactNode;
};

const LangWrap = (props: LangProps) => {
  const { lang } = useParams();
  if (lang && Object.keys(langs).some((l) => l === lang)) {
    if (lang !== i18n.language) {
      // change to selected Language
      i18n.changeLanguage(lang);
    }

    return <>{props.children}</>;
  } else {
    return (
      <h4 style={{ color: "red" }}>
        The Language your selected is not supported.
      </h4>
    );
  }
};

export default UserRouter;
